/**
 * Cluster 6 · FAQ & data provenance
 *
 * Extracted verbatim from the DegreeDetail.jsx monolith (Feb 2026
 * refactor). Receives the full parent context as a single `ctx`
 * prop so we don't have to thread dozens of individual props.
 * Preserves every DOM node, class, and data-testid so the visible
 * behaviour is identical to the pre-refactor page.
 */
import { ClusterMember } from "@/components/app/degree/ClusterLayout";
import { Section, Ev } from "@/components/app/degree/DegreeDetailBits";
import DiscoverUniPanel from "@/components/app/DiscoverUniPanel";

export default function Cluster6Sources({ ctx }) {
  const { d } = ctx;
  return (
    <ClusterMember cluster={6}>
      {d.hesa_stats?.faq_ai_generated?.qa?.length > 0 && (
        <Section id="faq" title="Frequently asked questions">
          <div className="text-xs text-stone-500 mb-3 font-mono">
            AI-generated from HESA Discover Uni data · Claude Haiku · {new Date(d.hesa_stats.faq_ai_generated.generated_at).toLocaleDateString()}
          </div>
          <div className="space-y-3" data-testid="hesa-faq-list">
            {d.hesa_stats.faq_ai_generated.qa.map((qa, i) => (
              <details
                key={i}
                data-testid={`hesa-faq-${i}`}
                className="rounded-lg border border-stone-200 bg-white p-3 group"
              >
                <summary className="cursor-pointer text-sm font-medium text-stone-900 flex items-start gap-2 list-none">
                  <span className="text-[#4C1D95] font-mono text-xs mt-0.5">Q{i + 1}</span>
                  <span className="flex-1">{qa.q}</span>
                  <span className="text-stone-400 text-xs group-open:rotate-90 transition">›</span>
                </summary>
                <div className="mt-2 pl-6 text-sm text-stone-700 leading-relaxed">{qa.a}</div>
              </details>
            ))}
          </div>
        </Section>
      )}

      <Section id="evidence" title="Data provenance">
        <p className="text-sm text-stone-600 max-w-2xl">Every field on this page carries an evidence stamp with source, URL, date checked, academic year, and confidence label (verified / estimated / not_published). Editors: update these on re-verification.</p>
        <Ev ev={d.record_evidence} />
        <div className="mt-6">
          <DiscoverUniPanel degree={d} />
        </div>
      </Section>
    </ClusterMember>
  );
}
